@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<ng-template #periodDateTimeTemplate let-fromYear="fromYear" let-tillYear="tillYear" let-tillYearEditorId="tillYearEditorId" let-fromYearEditorId="fromYearEditorId">
  @if (tillYear && fromYear !== tillYear) {
    <ng-container i18n="year period separator@@3207050836358092212">
    <time [attr.datetime]="fromYear | date:'yyyy'" [appEditorId]="fromYearEditorId">{{ fromYear | date:'yyyy' }}</time>
    to
    <time [attr.datetime]="tillYear | date:'yyyy'"  [appEditorId]="tillYearEditorId">{{ tillYear | date:'yyyy' }}</time>
  </ng-container>
  } @else {
    <time [attr.datetime]="fromYear | date:'yyyy'" [appEditorId]="fromYearEditorId">{{ fromYear | date:'yyyy' }}</time>
  }
</ng-template>

<div kb-layout="grid">
  <kb-chip-set kb-grid-item-columns="12">
    @for (period of attributes.periods; track period; let isFirst = $first) {
      <a kb-chip
        [class.selected]="isFirst"
        [routerLink]="['.']" [fragment]="getPeriodAnchor(period)"
      >
        <ng-container
          [ngTemplateOutlet]="periodDateTimeTemplate"
          [ngTemplateOutletContext]="{fromYear: period.fromYear, tillYear: period.tillYear, fromYearEditorId: period.editorIds?.fromYear, tillYearEditorId: period.editorIds?.tillYear}"
        ></ng-container>
      </a>
    }
  </kb-chip-set>

  @for (period of attributes.periods; track period) {
    <section kb-grid-item-columns="12" class="periods-container" #periodsContainerElement>
      <!--

      -->
      @if (anchor) {
        <a [id]="getPeriodAnchor(period)"></a>
      }
      <h2 kb-heading kb-section class="year--heading">
        <ng-container
          [ngTemplateOutlet]="periodDateTimeTemplate"
          [ngTemplateOutletContext]="{fromYear: period.fromYear, tillYear: period.tillYear, fromYearEditorId: period.editorIds?.fromYear, tillYearEditorId: period.editorIds?.tillYear}"
        ></ng-container>
      </h2>
      <div class="periods-content" kb-layout="grid">
        <div class="timeline-container">
          <div class="timeline-bar"></div>
        </div>

        @for (section of period.sections; track section) {
          <div kb-grid-item-columns="6" class="period--item" [appEditorId]="section.editorId">
            <div class="timeline-circle"></div>
            @if (section.attributes.fromDate) {
              <h3 kb-heading class="date--heading" type="divider">
                <ng-container
                  [ngTemplateOutlet]="periodDateTimeTemplate"
                  [ngTemplateOutletContext]="{fromYear: section.attributes.fromDate, tillYear: section.attributes.tillDate}"
                ></ng-container>
              </h3>
            }
            <section kb-card kb-color-variant="secondary-variant">
              @if (section.attributes.image) {
                <app-plain-image slot="picture"
                  [section]="section.attributes.image"
                ></app-plain-image>
              }
              <div slot="content">
                @if (section.attributes.headline) {
                  <h3 [appEditorId]="section.editorIds?.headline" kb-heading>{{ section.attributes.headline }}</h3>
                }
                <kb-html [appEditorId]="section.editorIds?.copyText" [html]="section.attributes.copyText"></kb-html>
              </div>
            </section>
          </div>
        }
      </div>
    </section>
  }
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
